import { useCallback, useMemo, useState } from 'react'

import type {
  UserResultCardProps,
  UseUserResultCardProps,
} from './UserResultCard.Types'

export const useUserResultCard = (
  data: UseUserResultCardProps
): UserResultCardProps => {
  const dataLength = data.length
  const [index, setIndex] = useState(0)

  const onClickNext = useCallback(() => {
    setIndex((prevIndex) => (prevIndex + 1) % dataLength)
  }, [dataLength])
  const onClickPrev = useCallback(() => {
    setIndex((prevIndex) => (prevIndex - 1 + dataLength) % dataLength)
  }, [dataLength])

  const currentData = useMemo(() => {
    if (index + 1 > dataLength) {
      return data[0]
    }
    return data[index]
  }, [data, dataLength, index])

  return {
    ...currentData,
    onClickPrev,
    onClickNext,
  }
}
